import { useTranslation } from 'next-i18next';

import { useMemo } from 'react';

import { Box, Heading } from '@chakra-ui/react';

import { v4 as uuid } from 'uuid';

import { AmenitiesCategorized } from '@app/components/molecules/amenities-categorized';
import { AmenitiesMobile } from '@app/components/molecules/amenities-mobile';
import { MAX_AMENITY_COUNT } from '@app/consts';
import { accommodationStaticSlice, commonUiStateSlice, useAppSelector } from '@app/state';

import { AmenitiesProps } from './amenities.props';

export const Amenities = ({ ...props }: AmenitiesProps) => {
    const { t } = useTranslation('accommodation', {
        keyPrefix: 'amenities',
    });

    const isMobileBrowser = useAppSelector(commonUiStateSlice.selectors.selectIsMobileVersion);
    const { internalAmenityGroups } = useAppSelector(
        accommodationStaticSlice.selectors.selectAmenitiesData,
    );

    const internalAmenityGroupsToShow = useMemo(
        () =>
            internalAmenityGroups
                ?.slice(0, MAX_AMENITY_COUNT)
                .map(group => ({ ...group, id: uuid() })),
        [internalAmenityGroups],
    );

    if (!internalAmenityGroupsToShow?.length) {
        return;
    }

    return (
        <Box {...props}>
            <Heading size={'md'}>{t('amenitiesHeader')}</Heading>
            {isMobileBrowser ? (
                <AmenitiesMobile mt={4} internalAmenityGroupsToShow={internalAmenityGroupsToShow} />
            ) : null}
            <AmenitiesCategorized
                mt={6}
                internalAmenityGroupsToShow={internalAmenityGroupsToShow}
                isSubsectionHidden={isMobileBrowser}
                hidden={isMobileBrowser}
            />
        </Box>
    );
};
